// removed by extract-text-webpack-plugin
module.exports = {"nf-rff-input-field":"nf-rff-input-field","nf-rff-input-field__error":"nf-rff-input-field__error","nf-rff-input-field__input":"nf-rff-input-field__input","nf-rff-input-field__label":"nf-rff-input-field__label","nf-rff-input-field__required":"nf-rff-input-field__required","nf-rff-input-field__row":"nf-rff-input-field__row"};


//////////////////
// WEBPACK FOOTER
// ./src/components/form/RFFNumberInputField/RFFInputField.scss
// module id = 5483
// module chunks = 1